import Flatpickr from "stimulus-flatpickr"

// import a theme (could be in your main CSS entry too...)
import "flatpickr/dist/themes/confetti.css"

// import the translation files and create a translation mapping
import { French } from "flatpickr/dist/l10n/fr.js"
import { english } from "flatpickr/dist/l10n/default.js"

// create a new Stimulus controller by extending stimulus-flatpickr wrapper controller
export default class extends Flatpickr {
  locales = {
    fr: French,
    en: english
  };

  connect () {
    // Hang a reference to the Stimulus controller instance off the DOM element
    // see https://leastbad.com/stimulus-power-move
    this.element[this.identifier] = this

    // define locale and global flatpickr settings for all datepickers
    this.config = {
      locale: this.locale,
      altInput: true
    }

    super.connect()
  }

  updateCheckOut (event) {
    const checkOutInput = document.querySelector('#contact_check_out')
    const checkOutMinDate = new Date(event.target.value)
    checkOutMinDate.setDate(checkOutMinDate.getDate() + 1)
    checkOutInput.flatpickr.fp.set('minDate', checkOutMinDate)
  }

  get locale () {
    if (this.locales && this.data.has("locale")) {
      return this.locales[this.data.get("locale")]
    }else{
      return null
    }

  }
}
